import React from "react";
import $ from 'jquery';
import ReactDOM from 'react-dom';
import shareLinkIcon from '../../components/Ebook/shareLinkIcon.png';
export const handleException = (data) => {
    if (data.wkErrorCode) {
        if ((data.wkErrorCode === "bus.exception.useragentfromdb.not.matched.with.session.authentication.token") ||
            (data.wkErrorCode === "bus.exception.tokengeneration.timestampfromdb.not.matched.with.session.authentication.token") ||
            (data.wkErrorCode === "bus.exception.devicetypefromrequest.not.matched.with.session.authentication.token") ||
            (data.wkErrorCode === "bus.exception.devicetypefromdb.not.matched.with.session.authentication.token") ||
            (data.wkErrorCode === "bus.exception.useragentfromrequest.not.matched.with.session.authentication.token") ||
            (data.wkErrorCode === "bus.exception.userprivatetokenfromdb.not.matched.with.session.authentication.token")
        ) {
            if (data.errorMessg === "You have been logged out of this session because you logged into Casebook Connect somewhere else.") {
                localStorage.clear();
                window.location.replace(window.location.origin + "/sessionExpired");
            }
        } else if (data.wkErrorCode === "bus.exception.session.authentication.token.expired.for.loggedin.user") {
            localStorage.clear();
            window.location.replace(window.location.origin + "/sessionInactivity");
        } else if ((data.wkErrorCode === "bus.exception.session.authentication.fail") ||
            (data.wkErrorCode === "bus.exception.useridfromrequestvo.not.matched.with.session.authentication.token") ||
            (data.wkErrorCode === "bus.exception.useridfromdb.not.matched.with.session.authentication.token")) {
            localStorage.clear();
            window.location.replace(window.location.origin + "/sessionGeneral");
        } else if ((data.wkErrorCode === "bus.exception.resource.isbn.is.invalid") ||
            (data.wkErrorCode === "bus.exception.book.isbn.is.invalid") ||
            (data.wkErrorCode === "bus.exception.chapter.id.is.invalid") ||
            (data.wkErrorCode === "bus.exception.user.does.not.have.access.to.this.book") ||
            (data.wkErrorCode === "bus.exception.user.does.not.have.access.to.this.resource")) {
            localStorage.removeItem("PPException");
            window.location.replace(window.location.origin + "/invalidUrl");
        }
    } else if (data.Exception) {
        localStorage.setItem("PPException", data.Exception);
        window.location.replace(window.location.origin + "/invalidUrl");
    }
};
export const displayNotesOnRight = (noteText, noteId, topValue, boxColor, isLink, mode) => {
    let allNotes = "";
    if (document.querySelector("#anchorElement" + noteId)) {
        document.querySelector("#anchorElement" + noteId).remove();
    }
    let containerTop = document.getElementById('notes-container').getBoundingClientRect().top;
    let clickableAnchorElement = document.createElement('A');
    clickableAnchorElement.id = 'anchorElement' + noteId;
    if (noteText !== undefined && noteText !== null)
        clickableAnchorElement.setAttribute('noteText', noteText);
    clickableAnchorElement.setAttribute('aria-label', noteText);
    clickableAnchorElement.style.color = '#333333';
    let notesText = document.createElement('div');
    notesText.id = 'notesDiv' + noteId;
    let timeCount = 1; let countOfAnnotationsInChapter = 300;
    if (localStorage.getItem("annotationListForChapter") !== null) {
        countOfAnnotationsInChapter = localStorage.getItem("annotationListForChapter").split(",").length;
    } else {
        countOfAnnotationsInChapter = 1000;
    }
    if (countOfAnnotationsInChapter < 50) {
        timeCount = 1;
    } else if (countOfAnnotationsInChapter > 50 && countOfAnnotationsInChapter < 150) {
        timeCount = 800;
    } else {
        timeCount = 1000;
    }
    if (noteText !== "" && noteText !== null && noteText !== undefined) {
        if ((noteText.length > 40 && noteText.split(" ").length < 5) || (noteText.length > 40 && noteText.split(" ")[0].length > 20) || (noteText.length > 25 && noteText.split(" ")[0].length > 20)) {
            notesText.className = "notesText overlapCheckClass  ellipsis";
            notesText.style.width = "150px";
        } else {
            notesText.className = "notesText overlapCheckClass";
        }
    } else {
        notesText.className = "notesText";
    }
    notesText.style.top = (topValue - containerTop - 4) + "px";
    if (noteText !== undefined && noteText !== null && mode !== "resize") {
        notesText.innerHTML = noteText; notesText.title = noteText;
    }
    let iconOverValue = 15; let minimizeNoteBookLinkFlag1 = document.querySelector('.expandNoteBookLink').getAttribute('aria-expanded');
    if (minimizeNoteBookLinkFlag1 === "true") { notesText.style.display = "none"; }
    else if (minimizeNoteBookLinkFlag1 === "false") { notesText.style.display = "block"; }
    let screenMode2 = localStorage.getItem("screenMode");
    if (screenMode2 === "split") { iconOverValue = 20; }
    else if (screenMode2 === "expand") { iconOverValue = 5; }
    let notesColor = document.createElement('span');
    notesColor.id = noteId; notesColor.className = "notesSpanBlock";
    notesColor.setAttribute('style', `background-color: ${boxColor} !important; top: ${(topValue - containerTop)} px;`);
    setTimeout(() => {
        allNotes = document.querySelectorAll('.notesText');
        let i; let lastNoteTopValue = 0; let lastNoteHeight = 0;
        let IconTopValue = topValue - containerTop + "px";
        setTimeout(() => {
            for (i = 0; i < allNotes.length; i++) {
                lastNoteHeight = allNotes[i].offsetHeight + iconOverValue;
                if (parseInt(allNotes[i].style.top) === parseInt(notesText.style.top)) {
                    lastNoteTopValue = parseInt(allNotes[i].style.top);
                    notesText.style.top = parseInt(allNotes[i].style.top) - 2 + lastNoteHeight + "px";
                    notesColor.style.top = parseInt(allNotes[i].style.top) + lastNoteHeight + "px";
                    IconTopValue = parseInt(allNotes[i].style.top) + lastNoteHeight + "px";
                    document.querySelector('#' + clickableAnchorElement.id + (isLink === true) ? ' .linkIcon' : ' .notesIcon').style.top = IconTopValue;
                    clickableAnchorElement.top = parseInt(allNotes[i].style.top) + lastNoteHeight + "px";
                }
                else if ((parseInt(allNotes[i].style.top) < (parseInt(notesText.style.top) + lastNoteHeight)) && (parseInt(allNotes[i].style.top) > (parseInt(notesText.style.top) - lastNoteHeight))) {
                    if (parseInt(allNotes[i].style.top) > lastNoteTopValue) {
                        lastNoteTopValue = parseInt(allNotes[i].style.top);
                        notesText.style.top = parseInt(allNotes[i].style.top) - 2 + lastNoteHeight + "px";
                        notesColor.style.top = parseInt(allNotes[i].style.top) + lastNoteHeight + "px";
                        IconTopValue = parseInt(allNotes[i].style.top) + lastNoteHeight + "px";
                        if (isLink === true) {
                            document.querySelector('#' + clickableAnchorElement.id + ' .linkIcon').style.top = IconTopValue;
                        } else {
                            document.querySelector('#' + clickableAnchorElement.id + ' .notesIcon').style.top = IconTopValue;
                        }
                        clickableAnchorElement.top = parseInt(allNotes[i].style.top) + lastNoteHeight + "px";
                    }
                }
            }
        }, timeCount);
        document.getElementById('notes-container').appendChild(clickableAnchorElement);
        if (isLink === true) {
            clickableAnchorElement.setAttribute('linkcomments', boxColor);
            ReactDOM.render(<i className="fas fa-link linkIcon" style={{ top: IconTopValue }} />, document.getElementById(clickableAnchorElement.id));
        } else {
            ReactDOM.render(<i className="far fa-file-alt notesIcon" style={{ top: IconTopValue }} />, document.getElementById(clickableAnchorElement.id));
            clickableAnchorElement.setAttribute('colorcodeid', boxColor);
        }
        clickableAnchorElement.appendChild(notesText);
        document.getElementById(clickableAnchorElement.id).addEventListener('click', function (e) { });
        if (document.getElementById('notesDiv' + noteId) !== null) {
            let currentAnnotationRect = document.getElementById('notesDiv' + noteId).getBoundingClientRect();
            let fetchedAnnotationRect = null;
            lastNoteHeight = 0;
            for (i = 0; i < allNotes.length; i++) {
                lastNoteHeight = allNotes[i].offsetHeight + 5;
                fetchedAnnotationRect = document.getElementById(allNotes[i].id).getBoundingClientRect();
                if (!(currentAnnotationRect.right < fetchedAnnotationRect.left ||
                    currentAnnotationRect.left > fetchedAnnotationRect.right ||
                    currentAnnotationRect.bottom < fetchedAnnotationRect.top ||
                    currentAnnotationRect.top > fetchedAnnotationRect.bottom)) {
                    if (fetchedAnnotationRect.top < currentAnnotationRect.top) {
                        if ((currentAnnotationRect.top - fetchedAnnotationRect.top - 10) < parseInt(document.querySelector("#" + allNotes[i].id).css("line-height"))) {
                            if (document.getElementById(allNotes[i].id).innerHTML.length > 1) {
                                $(document.getElementById(allNotes[i].id), { clamp: 1 });
                            }
                        } else if (document.getElementById(allNotes[i].id).innerHTML.length > 1) {
                            $(document.getElementById(allNotes[i].id), { clamp: 2 });
                        }
                    } else {
                        if ((fetchedAnnotationRect.top - currentAnnotationRect.top - 10) < parseInt($("#" + allNotes[i].id).css("line-height"))) {
                            if (document.getElementById(allNotes[i].id).innerHTML.length > 1) {
                                $(document.getElementById(allNotes[i].id), { clamp: 1 });
                            }
                        } else if (document.getElementById(allNotes[i].id).innerHTML.length > 1) {
                            $(document.getElementById(allNotes[i].id), { clamp: 2 });
                        }
                    }
                }
            }
            if (typeof (localStorage.getItem("addNoteStartParaId")) !== "undefined" && localStorage.getItem("addNoteStartParaId") !== "" && localStorage.getItem("addNoteStartParaId") !== null) {
                let currentAnnotStartPara = localStorage.getItem("addNoteStartParaId");
                localStorage.setItem("addNoteStartParaId", "");
                if (currentAnnotStartPara !== "") {
                    let currentAnnotParaHasHighlight = $("#" + currentAnnotStartPara).find("highlight");
                    let firstHighlightId = "";
                    let firstHighlightPosition = 0;
                    let currentNotePosition = 0;
                    let currentNoteHeight = 0;
                    let currentNoteTotalSpace = 0;
                    let clampVal = 1;
                    let noteLineHeight = parseInt($("#notesDiv" + noteId).css("line-height"));
                    if (currentAnnotParaHasHighlight.length > 1) {
                        for (let i = 1; i < currentAnnotParaHasHighlight.length; i++) {
                            if (currentAnnotParaHasHighlight[i].id.indexOf("_") === -1) {
                                firstHighlightId = currentAnnotParaHasHighlight[i].id;
                                break;
                            }
                        }
                        if (firstHighlightId !== "" && typeof ($("#" + firstHighlightId) !== "undefined")) {
                            if (typeof ($("#" + firstHighlightId).offset() !== "undefined")) {
                                firstHighlightPosition = $("#" + firstHighlightId).offset().top;
                                currentNotePosition = $("#" + noteId).offset().top;
                                currentNoteHeight = $("#notesDiv" + noteId).height();
                                currentNoteTotalSpace = currentNotePosition + currentNoteHeight;
                                if ((currentNoteTotalSpace) > firstHighlightPosition) {
                                    if (parseInt($("#" + noteId).attr("startOffset")) < parseInt($("#" + firstHighlightId).attr("startOffset"))) {
                                        if (firstHighlightPosition - currentNotePosition > 2 * noteLineHeight) {
                                            clampVal = 2;
                                        } else if (firstHighlightPosition - currentNotePosition > noteLineHeight) {
                                            clampVal = 1;
                                        }
                                        if ($("#notesDiv" + noteId).html().length > 10) {
                                            $(document.getElementById("notesDiv" + noteId), { clamp: clampVal });
                                        }
                                    }
                                    localStorage.setItem("addNoteStartParaId", "");
                                }
                            }
                        }
                    } else {
                        localStorage.setItem("addNoteStartParaId", "");
                        if (typeof (localStorage.getItem("addNoteNextParaId")) !== "undefined" && localStorage.getItem("addNoteNextParaId") !== "" && localStorage.getItem("addNoteNextParaId") !== null) {
                            let nextAnnotStartPara = localStorage.getItem("addNoteNextParaId");
                            localStorage.setItem("addNoteNextParaId", "");
                            if (nextAnnotStartPara !== "") {
                                let currentAnnotParaHasHighlight = $("#" + nextAnnotStartPara).find("highlight");
                                let firstHighlightId = ""; let firstHighlightPosition = 0;
                                let currentNotePosition = 0; let currentNoteHeight = 0;
                                let currentNoteTotalSpace = 0; let clampVal = 1;
                                let noteLineHeight = parseInt($("#notesDiv" + noteId).css("line-height"));
                                if (currentAnnotParaHasHighlight.length > 0) {
                                    for (let i = 0; i < currentAnnotParaHasHighlight.length; i++) {
                                        if (currentAnnotParaHasHighlight[i].id.indexOf("_") === -1) {
                                            firstHighlightId = currentAnnotParaHasHighlight[i].id;
                                            break;
                                        }
                                    }
                                    if (typeof ($("#" + firstHighlightId) !== "undefined") && typeof ($("#" + firstHighlightId).offset() !== "undefined")) {
                                        firstHighlightPosition = $("#" + firstHighlightId).offset().top;
                                        currentNotePosition = $("#" + noteId).offset().top;
                                        currentNoteHeight = $("#notesDiv" + noteId).height();
                                        currentNoteTotalSpace = currentNotePosition + currentNoteHeight;
                                        if ((currentNoteTotalSpace) > firstHighlightPosition) {
                                            if ($("#notesDiv" + noteId).parent().offset().top < $("#" + firstHighlightId).parent().offset().top) {
                                                if (firstHighlightPosition - currentNotePosition > 2 * noteLineHeight) {
                                                    clampVal = 2;
                                                } else if (firstHighlightPosition - currentNotePosition > noteLineHeight) {
                                                    clampVal = 1;
                                                }
                                                if ($("#notesDiv" + noteId).html().length > 10) {
                                                    $(document.getElementById("notesDiv" + noteId), { clamp: clampVal });
                                                }
                                            }
                                            localStorage.setItem("addNoteNextParaId", "");
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }, timeCount);
    setTimeout(() => { }, 2000);
}
export const displayBriefOnRight = (briefId, briefColor, topValue, labelText, briefNote, mode) => {
    let allBriefs = "";
    if (labelText !== null && labelText !== undefined && labelText !== "") {
        labelText = labelText.replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
    if ($("#briefAnchorElement" + briefId)) {
        $("#briefAnchorElement" + briefId).remove();
    }
    let containerTop = document.getElementById('notes-container').getBoundingClientRect().top;
    let clickableAnchorElement = document.createElement('A');
    clickableAnchorElement.id = 'briefAnchorElement' + briefId;
    clickableAnchorElement.setAttribute('briefNote', briefNote);
    clickableAnchorElement.setAttribute('colorcodeid', briefColor);
    clickableAnchorElement.setAttribute('aria-label', briefNote);
    clickableAnchorElement.style.color = '#333333';
    let bNotesText = document.createElement('div');
    bNotesText.id = 'notesDiv' + briefId;
    let timeCount = 1;
    let countOfAnnotationsInChapter = 300;
    if (localStorage.getItem("annotationListForChapter") !== null) {
        countOfAnnotationsInChapter = localStorage.getItem("annotationListForChapter").split(",").length;
    } else {
        countOfAnnotationsInChapter = 1000;
    }
    if (countOfAnnotationsInChapter < 50) {
        timeCount = 1;
    } else if (countOfAnnotationsInChapter > 50 && countOfAnnotationsInChapter < 150) {
        timeCount = 800;
    } else {
        timeCount = 1000;
    }
    bNotesText.style.top = (topValue - containerTop - 4) + "px";
    if (briefNote !== undefined && briefNote !== null && mode !== "resize") {
        bNotesText.innerHTML = briefNote;
        bNotesText.title = briefNote;
    }
    if ((briefNote.length > 40 && briefNote.split(" ").length < 5) || (briefNote.length > 40 && briefNote.split(" ")[0].length > 20) || (briefNote.length > 25 && briefNote.split(" ")[0].length > 20)) {
        bNotesText.className = "briefNotesText ellipsis";
        bNotesText.style.width = "150px";
    } else {
        bNotesText.className = "briefNotesText";
    }
    let iconOverValueB = 15; let minimizeNoteBookLinkFlag2 = document.querySelector('.expandNoteBookLink').getAttribute('aria-expanded');
    if (minimizeNoteBookLinkFlag2 === "true") { bNotesText.style.display = "none"; }
    else if (minimizeNoteBookLinkFlag2 === "false") { bNotesText.style.display = "block"; }
    let screenMode3 = localStorage.getItem("screenMode");
    if (screenMode3 === "split") { iconOverValueB = 20; }
    else if (screenMode3 === "expand") { iconOverValueB = 5; }
    let briefColor1 = document.createElement('span');
    briefColor1.id = briefId; briefColor1.className = "briefSpanBlock";
    briefColor1.setAttribute('style', `background-color: ${briefColor} !important; top: ${(topValue - containerTop)}px;`);
    setTimeout(() => {
        let allBriefs = $('.briefNotesText'); let i;
        let lastNoteTopValue = 0; let lastNoteHeight = 0;
        let IconTopValueB = topValue - containerTop + "px";
        setTimeout(() => {
            for (i = 0; i < allBriefs.length; i++) {
                lastNoteHeight = allBriefs[i].offsetHeight + iconOverValueB;
                if (parseInt(allBriefs[i].style.top) === parseInt(bNotesText.style.top)) {
                    lastNoteTopValue = parseInt(allBriefs[i].style.top);
                    bNotesText.style.top = parseInt(allBriefs[i].style.top) - 2 + lastNoteHeight + "px";
                    briefColor1.style.top = parseInt(allBriefs[i].style.top) + lastNoteHeight + "px";
                    IconTopValueB = parseInt(allBriefs[i].style.top) + lastNoteHeight + "px";
                    document.querySelector('#' + clickableAnchorElement.id + ' .notesIcon').style.top = IconTopValueB;
                    clickableAnchorElement.top = parseInt(allBriefs[i].style.top) + lastNoteHeight + "px";
                } else if ((parseInt(allBriefs[i].style.top) < (parseInt(bNotesText.style.top) + lastNoteHeight)) && (parseInt(allBriefs[i].style.top) > (parseInt(bNotesText.style.top) - lastNoteHeight))) {
                    if (parseInt(allBriefs[i].style.top) > lastNoteTopValue) {
                        lastNoteTopValue = parseInt(allBriefs[i].style.top);
                        bNotesText.style.top = parseInt(allBriefs[i].style.top) - 2 + lastNoteHeight + "px";
                        briefColor1.style.top = parseInt(allBriefs[i].style.top) + lastNoteHeight + "px";
                        IconTopValueB = parseInt(allBriefs[i].style.top) + lastNoteHeight + "px";
                        document.querySelector('#' + clickableAnchorElement.id + ' .notesIcon').style.top = IconTopValueB;
                        clickableAnchorElement.top = parseInt(allBriefs[i].style.top) + lastNoteHeight + "px";
                    }
                }
            }
        }, timeCount);
        document.getElementById('notes-container').appendChild(clickableAnchorElement);
        ReactDOM.render(<i className="far fa-file-alt notesIcon" style={{ top: IconTopValueB }} />, document.getElementById(clickableAnchorElement.id));
        clickableAnchorElement.appendChild(bNotesText);
        document.getElementById(clickableAnchorElement.id).addEventListener('click', function (e) { });
        if (document.getElementById('notesDiv' + briefId) !== null) {
            let currentAnnotationRect = document.getElementById('notesDiv' + briefId).getBoundingClientRect();
            let fetchedAnnotationRect = null;
            lastNoteHeight = 0;
            for (i = 0; i < allBriefs.length; i++) {
                lastNoteHeight = allBriefs[i].offsetHeight + 5;
                fetchedAnnotationRect = document.getElementById(allBriefs[i].id).getBoundingClientRect();
                if (!(currentAnnotationRect.right < fetchedAnnotationRect.left ||
                    currentAnnotationRect.left > fetchedAnnotationRect.right ||
                    currentAnnotationRect.bottom < fetchedAnnotationRect.top ||
                    currentAnnotationRect.top > fetchedAnnotationRect.bottom)) {
                    if (fetchedAnnotationRect.top < currentAnnotationRect.top) {
                        if ((currentAnnotationRect.top - fetchedAnnotationRect.top - 10) < parseInt($("#" + allBriefs[i].id).css("line-height"))) {
                            if (document.getElementById(allBriefs[i].id).innerHTML.length > 1) {
                                $(document.getElementById(allBriefs[i].id), { clamp: 1 });
                            }
                        } else {
                            if (document.getElementById(allBriefs[i].id).innerHTML.length > 1) {
                                $(document.getElementById(allBriefs[i].id), { clamp: 2 });
                            }
                        }
                    } else {
                        if ((fetchedAnnotationRect.top - currentAnnotationRect.top - 10) < parseInt($("#" + allBriefs[i].id).css("line-height"))) {
                            if (document.getElementById(allBriefs[i].id).innerHTML.length > 1) {
                                $(document.getElementById(allBriefs[i].id), { clamp: 1 });
                            }
                        } else {
                            if (document.getElementById(allBriefs[i].id).innerHTML.length > 1) {
                                $(document.getElementById(allBriefs[i].id), { clamp: 2 });
                            }
                        }
                    }
                }
            }
            if (typeof (localStorage.getItem("addNoteStartParaId")) !== "undefined" && localStorage.getItem("addNoteStartParaId") !== "" && localStorage.getItem("addNoteStartParaId") !== null) {
                let currentAnnotStartPara = localStorage.getItem("addNoteStartParaId");
                localStorage.setItem("addNoteStartParaId", "");
                if (currentAnnotStartPara !== "") {
                    let currentAnnotParaHasHighlight = $("#" + currentAnnotStartPara).find("highlight");
                    let firstHighlightId = "";
                    let firstHighlightPosition = 0;
                    let currentNotePosition = 0;
                    let currentNoteHeight = 0;
                    let currentNoteTotalSpace = 0;
                    let clampVal = 1;
                    let noteLineHeight = parseInt($("#notesDiv" + briefId).css("line-height"));
                    if (currentAnnotParaHasHighlight.length > 1) {
                        for (let i = 1; i < currentAnnotParaHasHighlight.length; i++) {
                            if (currentAnnotParaHasHighlight[i].id.indexOf("_") === -1) {
                                firstHighlightId = currentAnnotParaHasHighlight[i].id;
                                break;
                            }
                        }
                        if (firstHighlightId !== "" && typeof ($("#" + firstHighlightId) !== "undefined")) {
                            if (typeof ($("#" + firstHighlightId).offset() !== "undefined")) {
                                firstHighlightPosition = $("#" + firstHighlightId).offset().top;
                                currentNotePosition = $("#" + briefId).offset().top;
                                currentNoteHeight = $("#notesDiv" + briefId).height();
                                currentNoteTotalSpace = currentNotePosition + currentNoteHeight;
                                if ((currentNoteTotalSpace) > firstHighlightPosition) {
                                    if (parseInt($("#" + briefId).attr("startOffset")) < parseInt($("#" + firstHighlightId).attr("startOffset"))) {
                                        if (firstHighlightPosition - currentNotePosition > 2 * noteLineHeight) {
                                            clampVal = 2;
                                        } else if (firstHighlightPosition - currentNotePosition > noteLineHeight) {
                                            clampVal = 1;
                                        }
                                        if ($("#notesDiv" + briefId).html().length > 10) {
                                            $(document.getElementById("notesDiv" + briefId), { clamp: clampVal });
                                        }
                                    }
                                    localStorage.setItem("addNoteStartParaId", "");
                                }
                            }
                        }
                    } else {
                        localStorage.setItem("addNoteStartParaId", "");
                        if (typeof (localStorage.getItem("addNoteNextParaId")) !== "undefined" && localStorage.getItem("addNoteNextParaId") !== "" && localStorage.getItem("addNoteNextParaId") !== null) {
                            let nextAnnotStartPara = localStorage.getItem("addNoteNextParaId");
                            localStorage.setItem("addNoteNextParaId", "");
                            if (nextAnnotStartPara !== "") {
                                let currentAnnotParaHasHighlight = $("#" + nextAnnotStartPara).find("highlight");
                                let firstHighlightId = "";
                                let firstHighlightPosition = 0;
                                let currentNotePosition = 0;
                                let currentNoteHeight = 0;
                                let currentNoteTotalSpace = 0;
                                let clampVal = 1;
                                let noteLineHeight = parseInt($("#notesDiv" + briefId).css("line-height"));
                                if (currentAnnotParaHasHighlight.length > 0) {
                                    for (let i = 0; i < currentAnnotParaHasHighlight.length; i++) {
                                        if (currentAnnotParaHasHighlight[i].id.indexOf("_") === -1) {
                                            firstHighlightId = currentAnnotParaHasHighlight[i].id;
                                            break;
                                        }
                                    }
                                    if (typeof ($("#" + firstHighlightId) !== "undefined") && typeof ($("#" + firstHighlightId).offset() !== "undefined")) {
                                        firstHighlightPosition = $("#" + firstHighlightId).offset().top;
                                        currentNotePosition = $("#" + briefId).offset().top;
                                        currentNoteHeight = $("#notesDiv" + briefId).height();
                                        currentNoteTotalSpace = currentNotePosition + currentNoteHeight;
                                        if ((currentNoteTotalSpace) > firstHighlightPosition) {
                                            if ($("#notesDiv" + briefId).parent().offset().top < $("#" + firstHighlightId).parent().offset().top) {
                                                if (firstHighlightPosition - currentNotePosition > 2 * noteLineHeight) {
                                                    clampVal = 2;
                                                } else if (firstHighlightPosition - currentNotePosition > noteLineHeight) {
                                                    clampVal = 1;
                                                }
                                                if ($("#notesDiv" + briefId).html().length > 10) {
                                                    $(document.getElementById("notesDiv" + briefId), { clamp: clampVal });
                                                }
                                            }
                                            localStorage.setItem("addNoteNextParaId", "");
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }, timeCount);
    setTimeout(() => { }, 2000);
}
export const displayLinksOnLeft = (linkId, topValue, urlText, urlComment, checkboxStatus, linkEditingForproffessor, mode) => {
    if (document.getElementById("linkAnchorElement" + linkId)) {
        document.getElementById("linkAnchorElement" + linkId).remove();
    }
    let containerTop = document.getElementById('links-container').getBoundingClientRect().top;
    let clickableAnchorElement = document.createElement('A');
    clickableAnchorElement.id = 'linkAnchorElement' + linkId;
    let linkIcon = document.createElement('IMG');
    linkIcon.className = "linksIcon display-inline-block";
    linkIcon.style.top = (topValue - containerTop - 2) + "px";
    linkIcon.src = shareLinkIcon;
    linkIcon.style.width = '30px';
    linkIcon.style.height = 'auto';
    linkIcon.style.position = 'absolute';
    if (urlComment !== undefined && urlComment !== null && urlComment !== "") {
        linkIcon.setAttribute("urlComments", urlComment.replace(/</g, "&lt;").replace(/>/g, "&gt;"));
    }
    else { linkIcon.setAttribute("urlComments", ""); }
    linkIcon.setAttribute("urlText", urlText);
    linkIcon.setAttribute("shareLinkChecked", checkboxStatus);
    linkIcon.setAttribute("linkEditingForproffessor", linkEditingForproffessor);
    let linkText = document.createElement('div');
    linkText.id = 'linkDiv' + linkId;
    linkText.style.top = (topValue - containerTop - 2) + "px";
    linkText.className = "linksIcon linksText";
    linkText.style.right = "70px";
    if (urlComment !== undefined && urlComment !== null && urlComment !== "" && mode !== "resize") {
        linkText.innerHTML = urlComment;
        linkText.setAttribute("urlComments", urlComment.replace(/</g, "&lt;").replace(/>/g, "&gt;"));
    }
    else { linkIcon.setAttribute("urlComments", ""); }
    linkText.setAttribute("urlText", urlText);
    linkText.setAttribute("shareLinkChecked", checkboxStatus);
    linkText.setAttribute("linkEditingForproffessor", linkEditingForproffessor);
    let minimizeNoteBookLinkFlag3 = document.querySelector('.minimizeNoteBookLink').getAttribute('aria-expanded');
    if (minimizeNoteBookLinkFlag3 === "true") { linkText.style.visibility = "hidden"; }
    else if (minimizeNoteBookLinkFlag3 === "false") { linkText.style.visibility = "visible"; }
    let minimizeNoteBookLinkFlag4 = document.querySelector('.expandNoteBookLink').getAttribute('aria-expanded');
    if (minimizeNoteBookLinkFlag4 === "false") { linkText.style.visibility = "hidden"; }
    else if (minimizeNoteBookLinkFlag4 === "true") { linkText.style.visibility = "visible"; }
    let iconOverValueL1 = 15; let screenMode3 = localStorage.getItem("screenMode");
    if (screenMode3 === "split") { iconOverValueL1 = 20; }
    else if (screenMode3 === "expand") { iconOverValueL1 = 5; }
    let allLinks = $('.linksIcon');
    allLinks.sort(function (a, b) {
        if (a.style.top > b.style.top)
            return 1;
        if (a.style.top < b.style.top)
            return -1;
        return 0;
    });
    let i; let lastNoteTopValue = 0; let lastNoteHeight = 0;
    for (i = 0; i < allLinks.length; i++) {
        lastNoteHeight = allLinks[i].offsetHeight + iconOverValueL1;
        if (parseInt(allLinks[i].style.top) === parseInt(linkIcon.style.top)) {
            lastNoteTopValue = parseInt(allLinks[i].style.top);
            linkIcon.style.top = parseInt(allLinks[i].style.top) - 2 + lastNoteHeight + "px";
            linkText.style.top = parseInt(allLinks[i].style.top) + lastNoteHeight + "px";
            clickableAnchorElement.top = parseInt(allLinks[i].style.top) + lastNoteHeight + "px";
        } else if ((parseInt(allLinks[i].style.top) < (parseInt(linkIcon.style.top) + parseInt(lastNoteHeight))) && (parseInt(allLinks[i].style.top) > (parseInt(linkIcon.style.top) - parseInt(lastNoteHeight)))) {
            if (parseInt(allLinks[i].style.top) > lastNoteTopValue) {
                lastNoteTopValue = parseInt(allLinks[i].style.top);
                linkIcon.style.top = parseInt(allLinks[i].style.top) + 7 + parseInt(lastNoteHeight) + "px";
                linkText.style.top = parseInt(allLinks[i].style.top) + lastNoteHeight + "px";
                clickableAnchorElement.top = parseInt(allLinks[i].style.top) + parseInt(lastNoteHeight) + "px";
            }
        }
    }
    clickableAnchorElement.appendChild(linkIcon);
    clickableAnchorElement.appendChild(linkText);
    document.getElementById('links-container').appendChild(clickableAnchorElement);
    document.getElementById(clickableAnchorElement.id).addEventListener('click', function (e) { });
    let allrTsIcon = $('.rTsIcon');
    for (let j = 0; j < allrTsIcon.length; j++) {
        let differenceInTop = 0;
        if (parseInt(linkIcon.style.top) >= parseInt(allrTsIcon[j].style.top)) {
            differenceInTop = parseInt(linkIcon.style.top) - parseInt(allrTsIcon[j].style.top);
            if (differenceInTop < 20) {
                allrTsIcon[j].remove();
                allrTsIcon[j].style.top = parseInt(linkIcon.style.top) + 7 + parseInt(lastNoteHeight) + "px";
                document.getElementById('links-container').appendChild(allrTsIcon[j]);
            }
        }
    }
}
export const reCalculateNotesOnRight = (mode) => {
    let fetchedNoteText, fetchedNoteId, calculatedYvalue, fetchedBackgroundColor;
    document.querySelectorAll('.highlightedText').forEach(function (el) {
        if (document.querySelector('#notesDiv' + el.id) !== null) {
            fetchedNoteId = el.id;
            fetchedNoteText = document.querySelector('#notesDiv' + el.id).getAttribute("title");
            calculatedYvalue = document.getElementById(el.id).getBoundingClientRect().top;
            let gtId = document.getElementById(el.id);
            fetchedBackgroundColor = getComputedStyle(gtId).backgroundColor;
            displayNotesOnRight(fetchedNoteText, fetchedNoteId, calculatedYvalue, fetchedBackgroundColor, false, mode)
        }
    });
    document.querySelectorAll('.anchorElementText').forEach(function (el) {
        if (document.querySelector('#notesDiv' + el.id) !== null) {
            fetchedNoteId = el.id;
            fetchedNoteText = document.querySelector('#notesDiv' + el.id).getAttribute("title");
            calculatedYvalue = document.getElementById(el.id).getBoundingClientRect().top;
            let gtId = document.getElementById(el.id);
            fetchedBackgroundColor = getComputedStyle(gtId).backgroundColor;
            displayNotesOnRight(fetchedNoteText, fetchedNoteId, calculatedYvalue, fetchedBackgroundColor, true, mode)
        }
    });
    document.querySelectorAll('.anchorElementText').forEach(function (el) {
        if (document.querySelector('#linkDiv' + el.id) !== null) {
            fetchedNoteId = el.id;
            fetchedNoteText = document.querySelector('#linkDiv' + el.id).previousElementSibling.getAttribute("urltext");
            calculatedYvalue = document.getElementById(el.id).getBoundingClientRect().top;
            let urlComments = document.querySelector('#linkDiv' + el.id).previousElementSibling.getAttribute("urlComments");
            let shareLinkChecked = document.querySelector('#linkDiv' + el.id).previousElementSibling.getAttribute("shareLinkChecked");
            let linkEditingForproffessor = document.querySelector('#linkDiv' + el.id).previousElementSibling.getAttribute("linkEditingForproffessor");
            let gtId = document.getElementById(el.id);
            fetchedBackgroundColor = getComputedStyle(gtId).backgroundColor;
            displayLinksOnLeft(fetchedNoteId, calculatedYvalue, fetchedNoteText, urlComments, shareLinkChecked, linkEditingForproffessor, mode)
        }
    });
}
export const reCalculateBriefOnRight = (mode) => {
    let fetchedBriefNoteText, fetchedBriefLabelText, fetchedBriefNoteId, calculatedYvalue1, fetchedBackgroundColor1;
    document.querySelectorAll('.briefElementText').forEach(function (el) {
        if (document.querySelector('#briefAnchorElement' + el.id) !== null) {
            fetchedBriefNoteId = el.id;
            fetchedBriefLabelText = document.querySelector('#briefAnchorElement' + el.id).getAttribute("labelname");
            fetchedBriefNoteText = document.querySelector('#briefAnchorElement' + el.id).getAttribute('briefnote');
            calculatedYvalue1 = document.getElementById(el.id).getBoundingClientRect().top;
            let gtId1 = document.getElementById(el.id);
            fetchedBackgroundColor1 = getComputedStyle(gtId1).backgroundColor;
            displayBriefOnRight(fetchedBriefNoteId, fetchedBackgroundColor1, calculatedYvalue1, fetchedBriefLabelText, fetchedBriefNoteText, mode);
        }
    });
}
export const checkBriefOverNoteForOverlap = () => {
    let allNoteBriefText = $(".overlapCheckClass");
    allNoteBriefText.sort(function (a, b) {
        if (parseInt(a.style.top) > parseInt(b.style.top))
            return 1;
        if (parseInt(a.style.top) < parseInt(b.style.top))
            return -1;
        return 0;
    });
    let currentNote = null;
    let prevNote = null;
    let prevNoteHeightWithTop = 0;
    let currentNoteHeightWithTop = 0;
    let prevNoteTop = 0;
    let currentNoteTop = 0;
    for (let i = 1; i < allNoteBriefText.length; i++) {
        currentNote = allNoteBriefText[i];
        prevNote = allNoteBriefText[i - 1];
        prevNoteHeightWithTop = parseInt(prevNote.style.top) + prevNote.offsetHeight;
        currentNoteHeightWithTop = parseInt(currentNote.style.top) + currentNote.offsetHeight;
        currentNoteTop = parseInt(currentNote.style.top);
        prevNoteTop = parseInt(prevNote.style.top);
        if ((currentNote.className.indexOf("notesText") !== -1 && prevNote.className.indexOf("notesText") !== -1) || (prevNote.className.indexOf("briefNotesText") !== -1 && currentNote.className.indexOf("briefNotesText") !== -1)) {
            if (prevNoteTop < currentNoteTop) {
                if (prevNoteHeightWithTop > currentNoteTop) {
                    if (prevNote.className.indexOf("notesText") !== -1) {
                        document.querySelectorclamp(document.getElementById(prevNote.id), { clamp: 2 });
                    } else {
                        let elemToClamp = "notesDiv" + prevNote.id.slice(12);
                        document.querySelectorclamp(document.getElementById(elemToClamp), { clamp: 2 });
                    }
                }
            }
        }
    }
}
